import React from "react"
import Button from "components/Button"
import ModalButtons from "components/ModalButtons"
import LabelValue from "components/LabelValue"
import Loader from "components/Loader"
import { dipRequest } from "data/dip/api"
import withModal from "hoc/withModal"
import { toastError, toastSuccess } from "data/toasts/rx"
import * as R from "ramda"

const SendReportToTaMSModal = ({ close, report, taxAccount, refetch }) => {
  const [submitLoading, setSubmitLoading] = React.useState(false)

  const handleSubmit = () => {
    setSubmitLoading(true)
    dipRequest.submitReportMS(report.id).subscribe({
      next: () => {
        setSubmitLoading(false)
        toastSuccess("Report successfully sent.")
        close()
        refetch()
      },
      error: (error) => {
        setSubmitLoading(false)
        const message = error.text || "Failed to send report."
        toastError(message)
      },
    })
  }

  return (
    <>
      <LabelValue mb={20} label="Filing entity name" value={report.entityName} />
      <LabelValue mb={20} label="Filing entity ID" value={taxAccount.elster ?? taxAccount.bop ?? report.entityId} />
      <LabelValue mb={20} label="Account type" value={taxAccount.elster ? "Elster" : taxAccount.bop ? "BOP" : "N/A"} />

      <ModalButtons>
        <Button secondary type="button" onClick={close} text="Cancel" disabled={submitLoading} />
        <Button text="Send report to tax authority" onClick={handleSubmit} disabled={submitLoading} />
      </ModalButtons>
      {submitLoading && <Loader center />}
    </>
  )
}

export default R.compose(
  withModal(R.always("Send report to tax authority")),
)(SendReportToTaMSModal)
